module.exports = __webpack_public_path__ + "img/logo.03bf6e29.svg";